module.exports = __webpack_public_path__ + "img/gu.10a27bf1.svg";